module.exports = __webpack_public_path__ + "img/29.10.pH.684d4741.png";